import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-block-opacity")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-block-opacity")),
  head: () => ({
    meta: [
      { title: "شفافيّة بلوكات الهوم — إدارة" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
